import { useSearchParams } from 'react-router-dom';

export const useBoxParams = (boxId: number) => {
  const [params, setParams] = useSearchParams();
  const id = params.get('id') ?? '-1';
  const isSelected = id ? parseInt(id) === boxId : false;

  const setBoxIdParam = () => setParams(`id=${boxId}`);
  return { isSelected, setBoxIdParam };
};
